import Footer from "./components/Footer";
import Header from "./components/Header";
import MetaComponent from "./components/MetaComponent";

import Categories from "./home/Categories";
import Products from "./home/Products";
import Hero from "./home/Hero";
import Features from "./home/Features";
import Shopgram from "./home/Shopgram";
import Banner from "./home/Banner";
import Collections from "./home/Collections";
import {useLocation} from "react-router-dom";
import {useEffect, useState} from "react";
import TopProducts from "./home/TopProducts";
import BestSellers from "./home/BestSellers";
// import Products2 from "./home/Products2";


const metadata = {
    title: `Home Page || ${process.env.REACT_APP_META_TITLE}`,
    description: process.env.REACT_APP_META_DESCRIPTION,
};

export default function HomePage({onPageReady}) {

    const location = useLocation();

    const [catReady, setCatReady] = useState(false);
    const [prodReady, setProdReady] = useState(false);
    const [collReady, setCollReady] = useState(false);
    const [gramReady, setGramReady] = useState(false);


    useEffect(() => {
        if (catReady && prodReady && collReady && gramReady) {
            onPageReady?.();
        }
    }, [catReady, prodReady, collReady, gramReady]);

    useEffect(() => {
        if (location.state?.showLogin) {
            const offcanvasEl = document.getElementById("login");
            if (offcanvasEl && window.bootstrap?.Offcanvas) {
                const instance =
                    window.bootstrap.Offcanvas.getInstance(offcanvasEl) ||
                    new window.bootstrap.Offcanvas(offcanvasEl);
                instance.show(); // ✅ login panelini aç
            }
        }
    }, [location.state]);



    return (
        <>
            <MetaComponent meta={metadata} />
            <Header />
            <Hero />
            <Categories onLoaded={() => setCatReady(true)} />
            <TopProducts
                cardStyleClass="grid style-2"
                tooltipDirection="top"
                onLoaded={() => setProdReady(true)}
            />
            <Banner />
            <BestSellers
                cardStyleClass="grid style-2"
                tooltipDirection="top"
                onLoaded={() => setProdReady(true)}
            />
            <Collections onLoaded={() => setCollReady(true)} />
            <Shopgram onLoaded={() => setGramReady(true)} />
            <Features />
            <Footer />
        </>
    );
}
